import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import { ThreeJSClass } from '@threeJS/threejs.helper';

import Simulator from '../simulator';

export default class Camera extends ThreeJSClass {
  _camera: THREE.PerspectiveCamera;
  _controls: OrbitControls;

  constructor(simulation: Simulator) {
    super(simulation);
    this._camera = this._initSceneCamera();
    this._controls = this._initControls();
    this._simulation.scene.add(this._camera);
  }

  _initSceneCamera() {
    // const camera = new THREE.PerspectiveCamera(
    //   75,
    //   window.innerWidth / window.innerHeight,
    //   0.1,
    //   10,
    // );
    // camera.position.set(-0.5, 1.5, -1.5);
    const camera = new THREE.PerspectiveCamera(
      20,
      this._simulation._sizes.width / this._simulation._sizes.height,
      0.1,
      1000
    );
    camera.position.set(4, 4, -10);
    return camera;
  }

  _initControls() {
    const controls = new OrbitControls(this._camera, this._simulation.canvas);
    controls.enableDamping = true;
    controls.enableZoom = false;
    controls.enablePan = false;

    // controls.minDistance = 1.2;
    // controls.maxDistance = 5;
    // controls.target.set(0, 0.3, 0);

    // const angleOffset = Math.PI / 12;
    // controls.minPolarAngle = angleOffset;
    // controls.maxPolarAngle = Math.PI / 2 - angleOffset;
    return controls;
  }

  onTick(elapsedTime: number): void {
    if (this._controls) {
      this._controls.update();
    }
    // if (this._camera) {
    //   this._camera.aspect = window.innerWidth / window.innerHeight;
    // this._camera.updateProjectionMatrix();

    // }
  }
  onToggleTheme(isDarkMode: boolean): void {}
  onToggleDebug(isDebug: boolean): void {}
  dispose(): void {}
}
